export const divCardRewardsData: Record<string, string> = {};
